function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2-2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M2 20.8H0V3.267A3.26 3.26 0 01.946.96a3.22 3.22 0 012.3-.96h14.587v2H3.246a1.229 1.229 0 00-.878.368 1.269 1.269 0 00-.368.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M20.113 3.6H6.971a3.25 3.25 0 00-3.246 3.246v17.308A3.249 3.249 0 006.971 27.4h13.142c1.79 0 3.246-.031 3.246-1.821V5.554c0-1.79-1.459-1.954-3.246-1.954zm-6.521 5.748a3.257 3.257 0 11-3.257 3.257 3.258 3.258 0 013.257-3.257zm6.59 11.618v1.363H6.667v-1.363h.008c0-.026-.008-.052-.008-.079 0-2.071 3.026-3.387 6.758-3.387s6.757 1.316 6.757 3.387c0 .027-.006.053-.007.079z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M26.725 27.4H8.308v-2h17.417V5.65h-5.1v-2h6.1a1 1 0 011 1V26.4a1 1 0 01-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M21.058 11.3h5.767v2h-5.767zM21.058 18.7h5.767v2h-5.767z"
})));

var SvgCopyAddressmin = function SvgCopyAddressmin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27.725 27.4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyAddressmin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CopyAddress.min.6ae56308.svg";
export { ForwardRef as ReactComponent };